module.exports = __webpack_public_path__ + "img/caseimeiopposmall.6bb3bdc4.png";